import React from 'react'
import {useLocation,useNavigate } from 'react-router-dom';

import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';

const AssessmentSuccessPage = () => {

    // React routers
    const navigate = useNavigate();
    const location = useLocation();
    const urlparams = location.state;

    const date = new Date().toLocaleDateString("de-DE");

    return (
        <div>
            <div className="slidecontainer">
                <br />
                <br />
                <div className="row">
                    <div className="col-xl-6 col-lg-6 col-sm-12 col-md-6 standardnames">
                        <img src="../assets/icons/checksmall.png"  style={{ width: '10px', marginRight: '5px', float: 'right' }} draggable="false" alt=''/>
                        <div className='float-l'>
                            {urlparams.standard==='CIS' && (
                                <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-cis.png"   draggable="false" alt='CIS-Icon'/>
                            )}
                            {urlparams.standard==='ISO-27001' && (
                                <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-iso-27001.png"   draggable="false" alt='ISO-Icon'/>
                            )}
                            {urlparams.standard==='NIST' && (
                                <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-nist.png"   draggable="false" alt='NIST-Icon'/>
                            )}
                            {urlparams.standard==='COBIT' && (
                                <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-cobit.png"   draggable="false" alt='COBIT-Icon'/>
                            )}
                            {urlparams.standard==='TISAX' && (
                                <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-tisax.png"   draggable="false" alt='TISAX-Icon'/>
                            )}
                            {urlparams.standard==='NIS 2.0' && (
                                <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-nis2.png"   draggable="false" alt='NIS-Icon'/>
                            )}
                            {urlparams.standard==='Ransomware' && (
                                <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-ransomware.png"   draggable="false" alt='Ransomware-Icon' />
                            )}
                            {urlparams.standard==='Data Protection' && (
                                <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-data-protection.png"   draggable="false" alt='DP-Icon'/>
                            )}
                            {urlparams.standard==='Supplier Risk' && (
                                <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-supplier-risk.png"   draggable="false" alt='SR-Icon'/>
                            )}
                        </div>
                        <div className='mx-2 float-l'>
                            <h3> 
                                <span> { urlparams.standard }  </span>
                            </h3>
                            <p>Assessment submitted successfully</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="submittedReview">
                        <div className="col-xl-6 col-lg-6 col-sm-12 col-md-6">
                            <div className='txt-c'>
                                <img src="../assets/icons/checkbig.png" className='w-50' draggable="false" alt='' />
                                <h5>Submitted for review!</h5>
                                <p>A Compliance manager will review the assessment.</p>
                                <span>Report id: {urlparams.assessmentid}</span>
                                <p className="date">Date: {date}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='back-btn'>
                    <button className="back-to-home-button py-sm px-xl ml-sm my-lg" onClick={()=>navigate('/cap/user-pendingassessments')}><ArrowLeftIcon  /> Back to home</button>
                </div>
            </div>
        </div>
    )
}

export default AssessmentSuccessPage;
